import { render, staticRenderFns } from "./shixin.vue?vue&type=template&id=f9a19056"
import script from "./shixin.vue?vue&type=script&lang=ts"
export * from "./shixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports